import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const YelpIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-8 0 27 15"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m1.13099 1.51587c1.191-1.054862 2.58743-1.797067 4.72317-1.413336v6.795056c-.09153.32612-.36611.39863-.60407.21744zm8.52389 2.4733c.95682.59153 2.02762 1.77388 2.33102 3.51509l-4.59919.73702c-.26524-.09983-.46472-.26461-.43928-.65232zm-2.13075 5.82855c-.29672.06598-.45362.24248-.38447.59798l2.3262 3.8977c1.03444-.4698 2.06694-1.5663 2.53414-3.191zm-2.38907.54358c.30767-.0395.59505-.0453.6865.2718l.13733 4.3488c-1.5113.1107-2.77161-.2755-3.62474-1.4677zm-.60416-2.01133c.21977.26142.3431.53647.05499.86977l-4.2289 1.46776c-.498535-1.36251-.4528916-2.64206 0-3.85955z"
        fill={color}
      />
    </Svg>
  )
}

export default YelpIconSvg
